import React from 'react';
import SEO from '../../components/SEO';
import Layout from '../../components/Layout';
import Container from '../../components/Container';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import { Desktop, Tablet } from '../../constants/responsive';
import { css } from '@emotion/core';
import { FormattedHTMLMessage, useIntl } from 'gatsby-plugin-intl';

import Email from '../../svgs/contact-us/email.svg';
import Phone from '../../svgs/contact-us/phone.svg';
import Whatsapp from '../../svgs/whatsapp.svg';
import Feedback from '../../svgs/contact-us/feedback-Icon.svg';
import ReqDemoBtn from '../../components/ReqDemo';
const SocialMedia = () => {
  return (
    <div
      css={css`
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: space-between;
        ${Tablet} {
          width: auto;
        }
        ${Desktop} {
          width: auto;
        }
      `}
    >
      <a
        href='https://www.linkedin.com/company/aqumon/'
        target='_blank'
        rel='noreferrer'
      >
        <i
          css={css`
            width: 66px;
            height: 66px;
            cursor: pointer;
            display: inline-block;
            background: url(/about/linkedin.png) center no-repeat;
            background-size: contain;
            ${Desktop} {
              width: 99px;
              height: 99px;
              margin-right: 28px;
              margin-left: 0px;
            }
          `}
        />
      </a>
      <a
        href='https://www.instagram.com/aqumonhk/'
        target='_blank'
        rel='noreferrer'
      >
        <i
          css={css`
            width: 66px;
            height: 66px;
            cursor: pointer;
            display: inline-block;
            background: url(/about/instagram.png) center no-repeat;
            background-size: contain;
            ${Desktop} {
              width: 99px;
              height: 99px;
              margin-right: 28px;
              margin-left: 0px;
            }
          `}
        />
      </a>

      <a
        href='https://www.facebook.com/aqumonx'
        target='_blank'
        rel='noreferrer'
      >
        <i
          css={css`
            width: 66px;
            height: 66px;
            cursor: pointer;
            display: inline-block;
            background: url(/about/facebook.png) center no-repeat;
            background-size: contain;
            ${Desktop} {
              width: 99px;
              height: 99px;
              margin-right: 28px;
              margin-left: 0px;
            }
          `}
        />
      </a>

      <a
        href='https://www.youtube.com/channel/UCcv2wk_nOBKtb4t0lnOt4vA'
        target='_blank'
        rel='noreferrer'
      >
        <i
          css={css`
            width: 66px;
            height: 66px;
            cursor: pointer;
            display: inline-block;
            background: url(/about/youtube.png) center no-repeat;
            background-size: contain;
            ${Desktop} {
              width: 99px;
              height: 99px;
              margin-right: 28px;
              margin-left: 0px;
            }
          `}
        />
      </a>
    </div>
  );
};
const Item = ({ icon, children }) => {
  return (
    <div
      css={css`
        display: flex;
        align-items: flex-start;
      `}
    >
      <div
        css={css`
          width: 25px;
          margin-top: 3px;
          margin-right: 16px;
        `}
      >
        {icon}
      </div>
      {children}
    </div>
  );
};

const ContactUsPage = () => {
  const intl = useIntl();
  const data = useStaticQuery(graphql`
    query {
      banner: file(relativePath: { eq: "contact-us/banner.png" }) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      hk: file(relativePath: { eq: "contact-us/hk-2023.png" }) {
        childImageSharp {
          fluid(maxWidth: 280) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      sz: file(relativePath: { eq: "contact-us/sz-2023.png" }) {
        childImageSharp {
          fluid(maxWidth: 280) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      sg: file(relativePath: { eq: "contact-us/sg.png" }) {
        childImageSharp {
          fluid(maxWidth: 280) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `);
  return (
    <Layout footerBlank>
      <SEO
        title={intl.formatMessage({ id: 'contact-us.title' })}
        description={intl.formatMessage({ id: 'contact-us.description' })}
        keywords={intl.formatMessage({ id: 'contact-us.keywords' })}
      />
      <div
        css={css`
          background: #f8f8f8;
          width: 100%;
          height: 260px;

          display: flex;
          justify-content: center;
          position: relative;
          overflow: hidden;
          ${Tablet} {
            height: 220px;
          }
          ${Desktop} {
            height: 330px;
          }
        `}
      >
        <Container
          css={css`
            z-index: 1;
          `}
        >
          <div
            css={css`
              padding-top: 62px;
              display: flex;
              flex-direction: column;
              align-items: center;
              color: #595959;
              ${Tablet} {
                justify-content: space-between;
                flex-direction: row;
                padding-top: 80px;
              }
              ${Desktop} {
                justify-content: space-between;
                flex-direction: row;
                padding-top: 139px;
              }
            `}
          >
            <span
              css={css`
                font-weight: 700;
                font-size: 32px;
                line-height: 44px;
                color: #595959;
                margin-bottom: 62px;
                ${Tablet} {
                  font-size: 48px;
                  line-height: 52px;
                  margin-bottom: 0px;
                }
                ${Desktop} {
                  font-size: 48px;
                  line-height: 52px;
                  margin-bottom: 0px;
                }
              `}
            >
              <FormattedHTMLMessage id='contact-us.title' />
            </span>
            <div>
              <SocialMedia />
            </div>
          </div>
        </Container>
      </div>
      <Container>
        <div
          css={css`
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-top: 40px;
            ${Tablet} {
            }
            ${Desktop} {
              margin-left: 120px;
              margin-top: 140px;
            }
          `}
        >
          <div
            css={css`
              width: 325px;
              ${Tablet} {
                width: 45%;
                margin-right: 10%;
                margin-bottom: 0px;
                margin-right: 0px;
              }
              ${Desktop} {
                width: 45%;
                margin-right: 10%;
              }
            `}
          >
            <p
              css={css`
                font-weight: 700;
                font-size: 24px;
                line-height: 33px;
                color: #333333;
                margin-bottom: 7px;
                ${Tablet} {
                  font-size: 30px;
                  line-height: 41px;
                }
                ${Desktop} {
                  font-size: 30px;
                  line-height: 41px;
                }
              `}
            >
              <FormattedHTMLMessage id='contact-us.Scientific' />
            </p>
            <p
              css={css`
                font-weight: 400;
                font-size: 14px;
                line-height: 19px;
                color: #333333;
                margin-bottom: 24px;
                ${Tablet} {
                  font-size: 20px;
                  line-height: 27px;
                }
                ${Desktop} {
                  font-size: 20px;
                  line-height: 27px;
                }
              `}
            >
              <FormattedHTMLMessage id='contact-us.enhance' />
            </p>
            <Item icon={<Email />}>
              <h5
                css={css`
                  color: #333333;
                `}
              >
                <b>
                  <FormattedHTMLMessage id='contact-us.email' />:
                </b>{' '}
                investmentsolutions@aqumon.com
              </h5>
            </Item>
            <Item icon={<Phone />}>
              <h5
                css={css`
                  color: #333333;
                `}
              >
                <b>
                  <FormattedHTMLMessage id='contact-us.hotline' />:
                </b>{' '}
                <br
                  css={css`
                    ${Tablet} {
                    }
                    ${Desktop} {
                      display: none;
                    }
                  `}
                />
                +852 3590 9951
                <br />
                <FormattedHTMLMessage id='contact-us.hours' />
              </h5>
            </Item>
          </div>
          <div
            css={css`
              width: 325px;
              ${Tablet} {
                width: 45%;
                margin-right: 10%;
                margin-bottom: 0px;
                margin-right: 0px;
              }
              ${Desktop} {
                width: 45%;
              }
            `}
          >
            <p
              css={css`
                font-weight: 700;
                font-size: 24px;
                line-height: 33px;
                color: #333333;
                margin-bottom: 7px;
                ${Tablet} {
                  font-size: 30px;
                  line-height: 41px;
                }
                ${Desktop} {
                  font-size: 30px;
                  line-height: 41px;
                }
              `}
            >
              <FormattedHTMLMessage id='contact-us.WealthTech' />
            </p>
            <p
              css={css`
                font-weight: 400;
                font-size: 14px;
                line-height: 19px;
                color: #333333;
                margin-bottom: 24px;
                ${Tablet} {
                  font-size: 20px;
                  line-height: 27px;
                }
                ${Desktop} {
                  font-size: 20px;
                  line-height: 27px;
                }
              `}
            >
              <FormattedHTMLMessage id='contact-us.Provide' />
            </p>
            <Item icon={<Email />}>
              <h5
                css={css`
                  color: #333333;
                `}
              >
                <b>
                  <FormattedHTMLMessage id='contact-us.email' />:
                </b>{' '}
                <br
                  css={css`
                    ${Tablet} {
                    }
                    ${Desktop} {
                      display: none;
                    }
                  `}
                />
                wealthtech@aqumon.com
              </h5>
            </Item>
            <Item icon={<Phone />}>
              <h5
                css={css`
                  color: #333333;
                `}
              >
                <b>
                  <FormattedHTMLMessage id='contact-us.hotline' />:
                </b>{' '}
                <br
                  css={css`
                    ${Tablet} {
                    }
                    ${Desktop} {
                      display: none;
                    }
                  `}
                />
                +852 3590 9951
                <br />
                <FormattedHTMLMessage id='contact-us.hours' />
              </h5>
            </Item>
            <div
              css={css`
                width: 166px;
                margin-bottom: 65px;
                ${Tablet} {
                  width: 179px;
                  height: 43px;
                  margin-bottom: 0px;
                }
                ${Desktop} {
                  width: 179px;
                  height: 43px;
                  margin-bottom: 0px;
                }
              `}
            >
              <ReqDemoBtn height={46} />
            </div>
          </div>
          <div
            css={css`
              ${Tablet} {
                margin-bottom: 0px;
                margin-right: 0px;
              }
              ${Desktop} {
                margin-top: 122px;
              }
            `}
          >
            <p
              css={css`
                font-weight: 700;
                font-size: 24px;
                line-height: 33px;
                color: #333333;
                margin-bottom: 7px;
                ${Tablet} {
                  font-size: 30px;
                  line-height: 41px;
                }
                ${Desktop} {
                  font-size: 30px;
                  line-height: 41px;
                }
              `}
            >
              <FormattedHTMLMessage id='contact-us.customer' />
            </p>
            <p
              css={css`
                font-weight: 400;
                font-size: 14px;
                line-height: 19px;
                color: #333333;
                margin-bottom: 24px;
                ${Tablet} {
                  font-size: 20px;
                  line-height: 27px;
                }
                ${Desktop} {
                  font-size: 20px;
                  line-height: 27px;
                }
              `}
            >
              <FormattedHTMLMessage id='contact-us.General' />
            </p>
            <Item icon={<Email />}>
              <h5
                css={css`
                  color: #333333;
                `}
              >
                <b>
                  <FormattedHTMLMessage id='contact-us.email' />:
                </b>{' '}
                <br
                  css={css`
                    ${Tablet} {
                    }
                    ${Desktop} {
                      display: none;
                    }
                  `}
                />
                cs@aqumon.com
              </h5>
            </Item>
            <Item icon={<Phone />}>
              <h5
                css={css`
                  color: #333333;
                `}
              >
                <b>
                  <FormattedHTMLMessage id='contact-us.hotline' />:
                </b>{' '}
                <br
                  css={css`
                    ${Tablet} {
                    }
                    ${Desktop} {
                      display: none;
                    }
                  `}
                />
                +852 3590 9951
                <br />
                <FormattedHTMLMessage id='contact-us.hours' />
              </h5>
            </Item>
            <Item icon={<Whatsapp />}>
              <h5
                css={css`
                  color: #333333;
                `}
              >
                <b>WhatsApp:</b>
                <br
                  css={css`
                    ${Tablet} {
                    }
                    ${Desktop} {
                      display: none;
                    }
                  `}
                />{' '}
                +852 3001 5836
              </h5>
            </Item>
            <div
              css={css`
                display: flex;
                margin-top: 20px;
              `}
            >
              <a
                css={css`
                  text-align: center;
                  margin-right: 55px;
                `}
                href={`/${intl.locale}/resources/faq/`}
              >
                <i
                  css={css`
                    width: 36px;
                    height: 30px;
                    cursor: pointer;
                    display: inline-block;
                    margin-bottom: 13px;
                    background: url(/about/faq.png) center no-repeat;
                    background-size: contain;
                    ${Desktop} {
                      margin-left: 0px;
                    }
                  `}
                ></i>
                <p
                  css={css`
                    font-weight: 700;
                    font-size: 14px;
                    line-height: 19px;
                    color: #333333;
                    ${Tablet} {
                      font-size: 20px;
                      line-height: 27px;
                    }
                    ${Desktop} {
                      margin-bottom: 24px;
                      font-size: 20px;
                      line-height: 27px;
                    }
                  `}
                >
                  {intl.formatMessage({ id: 'menu.faq' })}
                </p>
              </a>
              <a
                css={css`
                  text-align: center;
                  margin-right: 55px;
                `}
                href={`/${intl.locale}/resources/fee/`}
              >
                <i
                  css={css`
                    width: 36px;
                    height: 30px;
                    cursor: pointer;
                    display: inline-block;
                    margin-bottom: 13px;
                    background: url(/about/fee.png) center no-repeat;
                    background-size: contain;
                    ${Desktop} {
                      margin-left: 0px;
                    }
                  `}
                ></i>
                <p
                  css={css`
                    font-weight: 700;
                    font-size: 14px;
                    line-height: 19px;
                    color: #333333;

                    ${Tablet} {
                      font-size: 20px;
                      line-height: 27px;
                    }
                    ${Desktop} {
                      margin-bottom: 24px;
                      font-size: 20px;
                      line-height: 27px;
                    }
                  `}
                >
                  {intl.formatMessage({ id: 'menu.fee' })}
                </p>
              </a>
              <a
                css={css`
                  text-align: center;
                  margin-right: 55px;
                `}
                href={`/${intl.locale}/resources/legal/`}
              >
                <i
                  css={css`
                    width: 36px;
                    height: 30px;
                    cursor: pointer;
                    margin-bottom: 13px;
                    display: inline-block;
                    background: url(/about/legal.png) center no-repeat;
                    background-size: contain;
                    ${Desktop} {
                      margin-left: 0px;
                    }
                  `}
                ></i>
                <p
                  css={css`
                    font-weight: 700;
                    font-size: 14px;
                    line-height: 19px;
                    color: #333333;

                    ${Tablet} {
                      font-size: 20px;
                      line-height: 27px;
                    }
                    ${Desktop} {
                      margin-bottom: 24px;
                      font-size: 20px;
                      line-height: 27px;
                    }
                  `}
                >
                  {intl.formatMessage({ id: 'menu.legal' })}
                </p>
              </a>
            </div>
          </div>
        </div>
      </Container>
      <Container
        css={css`
          margin-top: 90px;
          ${Desktop} {
            margin-top: 140px;
          }
        `}
      >
        <h2
          css={css`
            text-align: center;
            ${Tablet} {
              text-align: center;
            }
            width: 100%;
          `}
        >
          <FormattedHTMLMessage id='contact-us.offices' />
        </h2>
        <div
          css={css`
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            ${Tablet} {
              justify-content: space-evenly;
            }
            ${Desktop} {
              flex-wrap: nowrap;
              margin-top: 10px;
              justify-content: space-evenly;
            }
          `}
        >
          {['hk', 'sz', 'sg'].map((code) => {
            return (
              <div
                key={code}
                css={css`
                  display: flex;
                  flex-direction: column;

                  width: 280px;
                  align-items: center;
                  text-align: center;
                  margin-bottom: ${code === 'sg' ? '-24px' : '40px'};
                  ${Tablet} {
                    margin-bottom: 0px;
                    width: 190px;
                  }
                  ${Desktop} {
                    width: 280px;
                  }
                `}
              >
                <div
                  css={css`
                    width: 180px;
                    height: 180px;
                    border-radius: 20px;
                    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
                    overflow: hidden;
                    margin-bottom: 24px;
                    ${Desktop} {
                      width: 280px;
                      height: 280px;
                    }
                  `}
                >
                  <Img
                    fluid={data[code].childImageSharp.fluid}
                    imgStyle={{ objectFit: 'fill' }}
                    loading='eager'
                  />
                </div>
                <h5
                  css={css`
                    margin-bottom: 0px;
                    ${Tablet} {
                      margin-bottom: 24px;
                    }
                  `}
                >
                  <b>
                    <FormattedHTMLMessage id={`contact-us.${code}.name`} />
                  </b>
                </h5>
                <h6>
                  <FormattedHTMLMessage id={`contact-us.${code}.address`} />
                </h6>
              </div>
            );
          })}
        </div>
      </Container>
    </Layout>
  );
};

export default ContactUsPage;
